// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./components/ui/AuthContext";
import { PreferencesProvider } from "./context/PreferencesContext";
import {
  clearChunkReloadFlags,
  tryRecoverChunkError,
} from "./utils/lazyWithRetry.js";

window.addEventListener("error", (event) => {
  tryRecoverChunkError(event?.error || event);
});

window.addEventListener("unhandledrejection", (event) => {
  tryRecoverChunkError(event?.reason || event);
});

window.addEventListener("load", () => {
  // App hat sauber geladen → nächste echte Chunk-Fehler wieder einmalig recovern.
  clearChunkReloadFlags();
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("_wtchunk")) {
      url.searchParams.delete("_wtchunk");
      window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    }
  } catch {
    /* ignore */
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <PreferencesProvider>
        <App />
      </PreferencesProvider>
    </AuthProvider>
  </React.StrictMode>
);
